export default {"src":"/_next/static/media/ApplicationUseCaseAnalysis.8d542807.svg","height":1186,"width":1094,"blurWidth":0,"blurHeight":0};